import React, { PureComponent } from 'react';
import PlayButton from './PlayButton';
import NoUiSlider from './NoUiSlider';

class Slider extends PureComponent {
  render() {
    return (
      <div className="ifdw-slider--wrapper">
        <PlayButton dispatch={this.props.dispatch} isPlaying={this.props.isPlaying}/>
        <div className="ifdw-slider--element">
          <NoUiSlider year={this.props.year} dispatch={this.props.dispatch}/>
        </div>
      </div>
    );
  }
};

export default Slider;



/** WEBPACK FOOTER **
 ** ./src/components/Slider/index.js
 **/